import {createAsyncThunk} from "@reduxjs/toolkit";
import {getDomainAdminService} from "../../../api/generated/domainAdmin";
import type {IAvailableUsersAvailableUsers as AvailableUser, IGetUsersByGroupGroupsUsers as AdminUser} from "../../../api/generated/models";

const api = getDomainAdminService();

export const fetchAdminUsers = createAsyncThunk('AdminList/fetch',
    async () => {
        const response = await api.getAdminUsers();
        return response
    }
);

export const fetchUsers = createAsyncThunk('AdminList/fetchUsers',
    async () => {
        // API returns array despite single-object spec
        const response = await api.getAvailable() as unknown as AvailableUser[];
        return response
    }
);

export const AddAdminUser = createAsyncThunk('AdminUser/add',
    async (providerUserId: string) => {
        const response = await api.postAdminUsersProviderUserIdSuperadmin(providerUserId);
        return response as AdminUser | undefined
    })

export const DeleteAdminUser = createAsyncThunk('AdminUser/delete',
    async (admin: AdminUser) => {
        await api.deleteAdminUsersId(admin.id ?? null)
        return admin.id
    })
